import React from 'react'
import { UiGetDevice, documentation as UiGetDeviceDoc } from "./uiGetDevice";
import StepManager from '../components/stepManager';
import { Redirect } from 'react-router-dom';
import { renderReport } from '../components/elementList';
import FormComponent from '../components/formComponent';

let documentation = {
    title: "Device History",
    subtitle: 'Generates a report file of the device data.',
    brief: <p>Allow to download a report file of the device data.</p>,
    content: <p></p>,

    steps: [
        { id: 0, ...UiGetDeviceDoc },
        {
            id: 1,
            title: 'Choose Device Data',
            brief: 'Choose the telemetry data to include in the history report.',
            content: "The chosen data field will be inserted in the generated report"

        },
        {
            id: 2,
            title: 'Generate History Report',
            brief: 'Generates a report with the complete device timeseries',
            content: <p><p>Click the <b>Download</b> button to get the file.</p>
                <p>Click the <b>Done</b> button when finished.</p></p>
        }
    ]
}

class UiDeviceHistory extends React.Component {

    static defaultProps = {
        FIELDTYPE: 'acuadori field',
    };
    constructor(props) {
        super(props)

        this.deviceService = this.props.services.device;

        this.stepManagerRef = React.createRef();
        this.state = {
            finished: false,
            nextRoute: this.props.nextRoute,

            selectedDevice: {},
            selectedKeys: [],
            deviceHistory: {}
        };
    }

    documentation = () => documentation;

    stepManagerAdvance = () => {
        const element = this.stepManagerRef.current;
        element.advance();
    };
    renderAlert = (message, variant) => {
        this.stepManagerRef.current.showAlert(message, variant);
    };
    handleSubmitError = (error) => {
        let message = 'Error: ' + error.message;
        this.renderAlert(message, 'warning');
    };
    stepManagerGoBack = () => {
        const element = this.stepManagerRef.current;
        element.goBack();
    }

    renderGetDevice = () => {
        return (
            <UiGetDevice
                error={this.handleSubmitError}
                services={{ device: this.deviceService }}
                deviceType={null}
                finished={(selectedDevice, deviceReport) => {
                    this.setState({ selectedDevice: selectedDevice });
                    this.deviceService.getTimeseriesKeys(selectedDevice.id.id).then((timeseriesKeys) => {
                        this.setState({ deviceTimeseriesKeys: timeseriesKeys })
                        this.stepManagerAdvance();
                    }).catch(this.handleSubmitError);
                }
                } />
        );
    }

    renderSelectTelemetryKeys = () => {
        let { selectedDevice, deviceTimeseriesKeys } = this.state;
        if (!selectedDevice) {
            return null;
        }

        let inputs = [];
        let initials = {};
        deviceTimeseriesKeys.forEach(keys => {
            inputs.push({ key: keys, type: 'checkbox', inputType: 'checkbox', label: `${keys}` });
            initials[keys] = true;
        });

        return (
            <div>
                <label className="h3">Choose the telemetry data to include in the history report</label>
                {
                    (deviceTimeseriesKeys.length > 0) &&
                    <FormComponent
                        initialValues={{ title: '', ...initials }}
                        validateFunc={this.handleValidate}
                        submitFunc={this.handleTelemetryKeys}
                        inputs={inputs}
                        bulkCheckboxControls={true}
                    />
                }
                {
                    (deviceTimeseriesKeys.length === 0) &&
                    <div class="p-4 m-4">
                        <button class="p-1 m-1 btn btn-outline-danger" onClick={
                            (event) => {
                                this.setState({ selectedDevice: null }, this.stepManagerGoBack)
                            }
                        }>Device empty: Choose another one</button>
                    </div>
                }

            </div>
        );
    }

    download = (filename, text) => {
        var element = document.createElement('a');
        element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text));
        element.setAttribute('download', filename);

        element.style.display = 'none';
        document.body.appendChild(element);

        element.click();

        document.body.removeChild(element);
    }

    renderGenerateReport = () => {
        let { selectedKeys, selectedDevice, deviceHistory } = this.state;

        if (!selectedKeys) { return null; }

        return (
            <div>
                <button type="button"
                    className="btn btn-outline-primary border-dark" /* align-items-start */
                    onClick={(event) => {
                        this.download(`telemetry_${selectedDevice.name}.json`, JSON.stringify(deviceHistory));
                    }}
                >Download JSON</button>

                <div className="m-2 p-4">
                    <button type="button" className="btn btn-info"
                        onClick={(event) => { this.stepManagerAdvance() }}>  Done  </button>
                </div>
            </div>
        );
    }

    handleTelemetryKeys = (selectedKeys) => {
        let { selectedDevice } = this.state;
        let keys = []

        Object.keys(selectedKeys).map(name => {
            let value = selectedKeys[name];
            if (true === value) {
                keys.push(name);
            }
            return true;
        });

        if (keys.length > 0) {
            this.deviceService.getDeviceHistory(selectedDevice.id.id, keys).then((response) => {
                this.setState({ selectedKeys: keys, deviceHistory: response }, this.stepManagerAdvance);
            }
            ).catch(this.handleSubmitError)
        }
        else {
            this.handleSubmitError("No Key selected!");
        }

        return false;
    }



    reportAllComponentData = () => {
        return this.state.selectedDevice.report;
    }

    render() {
        let documentation = this.documentation();
        let { selectedDevice, selectedKeys, finished } = this.state;
        if (!finished) {
            return (
                <div className="container-fluid">
                    <StepManager ref={this.stepManagerRef}
                        alert={{ active: true }}
                        startStepId={0} endStepId={2}
                        onFinished={() => {
                            //window.open( this.props.links.thingsboardRoutes.dashboards );
                            this.setState({ finished: true },
                                this.stepManagerAdvance());
                        }}
                        documentation={documentation}
                        stepList={[
                            {
                                stepId: 0, stepName: documentation.steps[0].title, formValue: this.renderGetDevice,
                                dataValue: () => renderReport({ "Device": selectedDevice ? selectedDevice.name : '' }),
                                documentation: documentation.steps[0]
                            },
                            {
                                stepId: 1, stepName: documentation.steps[1].title, formValue: this.renderSelectTelemetryKeys,
                                dataValue: () => renderReport(selectedKeys.map((value, index) => { return { key: index, value: value } })),
                                documentation: documentation.steps[1]
                            },
                            {
                                stepId: 2, stepName: documentation.steps[2].title, formValue: this.renderGenerateReport,
                                documentation: documentation.steps[2]
                            },
                        ]}
                    />

                </div>
            );
        } else {
            return (
                <div className="container-fluid">
                    {this.state.finished && <Redirect to={this.state.nextRoute} />}
                    {renderReport(selectedDevice.report)}
                </div>
            )
        }
    }
}


export default UiDeviceHistory;
export {UiDeviceHistory, documentation}